import { PublicNav, PublicFooter } from "@/components/app/PublicNav";

const steps = [
  { n: 1, t: "Siapkan Profil Perusahaan", d: "Login sebagai Admin Mitra, lengkapi nama, alamat, logo, dan penanggung jawab pada halaman Pengaturan." },
  { n: 2, t: "Tambahkan Bahan Baku", d: "Buka menu Master Data → Bahan Baku. Masukkan kode, nama, satuan, dan harga terkini beserta supplier." },
  { n: 3, t: "Buat Mix Design", d: "Susun formula produk. Tentukan bahan dan kuantitas standar, faktor waste, versi, dan status resep." },
  { n: 4, t: "Buat Batch Produksi", d: "Tekan “Batch Baru”, pilih produk dan mix design, isi target unit. Sistem otomatis menyalin resep sebagai baseline." },
  { n: 5, t: "Rekam Realisasi", d: "Isi bahan aktual, tenaga kerja, mesin, overhead, dan biaya lingkungan pada tab masing-masing." },
  { n: 6, t: "Hitung HPP", d: "Buka menu HPP → Hitung HPP Aktual. Sistem menampilkan varians terhadap standar dan snapshot harga." },
  { n: 7, t: "Simulasi Harga Jual", d: "Pilih perhitungan HPP, tentukan metode markup atau margin, target keuntungan, diskon, dan pajak." },
  { n: 8, t: "Buat Laporan", d: "Ekspor PDF atau Excel dari halaman HPP dan Batch untuk pimpinan dan mitra pengabdian." },
];

export default function Guide() {
  return (
    <div className="min-h-screen bg-slate-50">
      <PublicNav />
      <section className="max-w-3xl mx-auto px-6 py-16">
        <span className="gc-label">Panduan Singkat</span>
        <h1 className="gc-h1 mt-3">Delapan langkah menghasilkan HPP dan simulasi harga jual.</h1>
        <ol className="mt-10 space-y-5">
          {steps.map((s) => (
            <li key={s.n} className="gc-card flex gap-4">
              <div className="flex-shrink-0 h-10 w-10 rounded-full bg-emerald-600 text-white font-cabinet font-black flex items-center justify-center">{s.n}</div>
              <div>
                <h3 className="gc-h3">{s.t}</h3>
                <p className="text-sm text-slate-600 mt-1">{s.d}</p>
              </div>
            </li>
          ))}
        </ol>
      </section>
      <PublicFooter />
    </div>
  );
}
